import React, { useState, useEffect } from 'react';
import '../styles/EnterCompanyName.css';
import { Header, Footer, Input, Button, Loading } from '../components';
import { checkOnAuthStateChanged, cloudFunctionV2, getDocument } from '../functions';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';

function EnterCompanyName() {
    const [loggedIn, setLoggedIn] = useState(null);
    const [companyName, setCompanyName] = useState("");
    const [loading, setLoading] = useState(false);
    const [userId, setUserId] = useState(null);
    const [userData, setUserData] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;

    useEffect(() => {
        document.title = "Company Name | Clozers";
        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                setLoggedIn(true);

                const colRef = "users";
                const docRef = user.userId;
                setUserId(user.userId);
                const queryData = await getDocument(colRef, docRef);
                if ( queryData.status === 200 ) {
                    setUserData(queryData.data.data);
                    if ( queryData.data.data.companyId !== "" ) {
                        navigate("/");
                    }
                }
            }
            else {
                setLoggedIn(false);
                navigate("/");
            }
        };
        fetchUserData();

    }, [navigate]);

    const onChangeCompanyName = (e) => {
        setCompanyName(e.target.value);
    };

    const cta = async() => {
        setLoading(true);

        const startDate = new Date();
        const endDate = moment(startDate).add(1, 'month').toDate();
        const newObject = {
            autoBilling: true,
            companyId: "",
            companyName: companyName,
            credits: 3,
            endDate: endDate,
            id: "",
            logo: null,
            monthly: true,
            price: 0,
            startDate: startDate,
            subscriptions: [],
            users: [
                {
                    admin: true,
                    email: userData.email,
                    userId: userId,
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    date: new Date()
                }
            ]
        };

        const createCompanyURL = process.env.REACT_APP_CREATE_COMPANY;
        const createCompanyParams = {
            data: newObject,
            userId: userId
        };
        await cloudFunctionV2(createCompanyURL, createCompanyParams);

        if ( state !== undefined && state !== null && state.path !== undefined && state.path !== null ) {
            const path = state.path;
            navigate(path);
        }
        else {
            navigate("/");
        }
        setLoading(false);
    };

    return (
        <div className="enter-company-name-outer-container">
            <Header
                loggedIn={loggedIn}
            />
            <div className="enter-company-name-inner-container relative-container">
                {
                    loading === true &&
                    <Loading />
                }
                <div className="enter-company-name-title-container">
                    <h1 className="heading-large-bold colour-primary text-align-center">
                        Company name
                    </h1>
                    <span className="body-regular colour-primary block-text text-align-center">
                        If you don't have an LLC yet just write whatever you want
                    </span>
                </div>
                <div className="enter-company-name-body-container">
                    <div className="enter-company-name-form-container">
                        <Input
                            label={"Company name"}
                            labelType={"labelType"}
                            info={false}
                            value={companyName}
                            onChange={onChangeCompanyName}
                            placeholder={"Acme LLC"}
                            type="text"
                            leftUnit={null}
                            rightUnit={null}
                            unitSwitch={false}
                            leftUnitSelected={true}
                            unitSwitchFunc={null}
                            disabled={false}
                            multiline={false}
                            error={false}
                            onMouseEnter={null}
                            onMouseLeave={null}
                            reset={false}
                            resetFunc={null}
                            resetPosition={null}
                            focusMultiline={true}
                            prompt={false}
                        />
                    </div>
                    <div className="enter-company-name-button-container">
                          <Button
                            buttonType="primary-button"
                            size="large"
                            text={"Next"}
                            cta={cta}
                            disabled={companyName === "" || loading === true ? true : false}
                            leftIcon={null}
                            leftIconClass=""
                            rightIcon={null}
                            rightIconClass=""
                            alt=""
                            standardIcon={false}
                            badge={false}
                            badgeVal={null}
                            badgeBG={null}
                            buttonRef={null}
                            spinner={false}
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default EnterCompanyName;